import { loadScript } from '../loadScript'
import { loadCSS } from '../loadCSS'
import config from '../config'
import cpSite from '../cpSite'
import { waitModuleReady } from '../waitModuleReady'

/**
 * Включение библиотеки Element-UI v2
 */
const elementUi = {
  depend: ['vue'],
  state: {
    libJs: config.STATIC + 'libs/element-ui/2.15/index.js',
    libCss: config.STATIC + 'libs/element-ui/2.15/index.css',
    libRu: config.STATIC + 'libs/element-ui/2.15/locale/ru-RU.js',
    isActive: false
  },
  activate: function () {
    // Проверка наличия Vue
    if (!window.Vue) {
      cpSite.module.vue.activate()
      waitModuleReady(() => window.Vue, () => this.activateElementUi(), 30)
    } else {
      this.activateElementUi()
    }
  },
  activateElementUi: function () {
    // Повторно не инициализировать
    if (window.Vue.options.components?.ElButton) {
      this.state.isActive = true
      return true
    }
    loadScript(this.state.libJs)
    loadCSS(this.state.libCss)
    this.state.isActive = true
    if (config.DEVMODE) {
      console.log('active: Vue ElementUi')
    }
    return true
  },
  ru: function () {
    loadScript(this.state.libRu)
    waitModuleReady(() => (window.ELEMENT && window.ELEMENT.lang?.ruRU), () => { window.ELEMENT.locale(window.ELEMENT.lang.ruRU) }, 30)
  }
}
export default elementUi
